// Typings

import { DataTableColumnDefinition, DataTableRow } from '../DataTableTypes.js';

// Utils
import { getValue } from './getValue.js';

/**
 * Default value formatter fallback
 */
export const defaultFormatter = <TRow extends DataTableRow, TContext = unknown>({
  value,
}: {
  row: TRow;
  column: DataTableColumnDefinition<TRow, TContext>;
  value: any;
  context?: unknown;
}) => {
  if (value === undefined || value === null) {
    return '-';
  }

  if (typeof value === 'number' || typeof value === 'boolean' || typeof value === 'string') {
    return value.toString();
  }

  if (Array.isArray(value) || (typeof value === 'object' && value.constructor === Object)) {
    return JSON.stringify(value, null, 2);
  }

  return 'NON_SERIALIZABLE';
};

/**
 * Given row and column definitions defined how to format the value
 */
export const formatValue = <TRow extends DataTableRow, TContext = unknown>(
  column: DataTableColumnDefinition<TRow, TContext>,
  row?: TRow,
  value = getValue(column, row)
): string => {
  if (!row) {
    return '';
  }

  return column.valueFormatter
    ? column.valueFormatter({ row, column, value })
    : defaultFormatter({ row, column, value });
};
